import {
  Component,
  OnInit,
  ViewChild,
  ElementRef
} from '@angular/core';

import { AppComponent } from 'src/app/app.component';
import { ThemingService } from 'src/app/theming.service';
import { environment } from 'src/environments/environment';
import { LambdaService } from 'src/app/lambda.service';

declare var $: any;

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {

  @ViewChild('editor') editorElement!: ElementRef;

  // 🔹 contenido
  contentES: string = '';
  contentEN: string = '';
  modules = {};
  // 🔹 estado idioma
  selectedLanguage: 'es' | 'en' = 'es';

  // 🔹 flags
  isENManuallyEdited: boolean = false;
  isTranslating: boolean = false;
  loading: boolean = false;
  isEditingTerms: boolean = false;

  constructor(
    private appComponent: AppComponent,
    private themingService: ThemingService,
    private lambdaService: LambdaService
  ) {}

  ngOnInit(): void {
    this.appComponent.goToTop();
    this.loadPolicy();
  }

  /* ============================================================
     GETTER / SETTER
  ============================================================ */

  get currentContent(): string {
    return this.selectedLanguage === 'es'
      ? this.contentES
      : this.contentEN;
  }

  set currentContent(value: string) {
    if (this.selectedLanguage === 'es') {
      this.contentES = value;

      // ❌ NO tocar EN aquí (esto rompía todo)

    } else {
      this.contentEN = value;
      this.isENManuallyEdited = true;
    }
  }

  /* ============================================================
     LOAD POLICY
  ============================================================ */

  private loadPolicy(): Promise<void> {
    return new Promise((resolve) => {

      const url = this.themingService.termsAndConditions + '?t=' + Date.now();

      const xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {

          const response = xhr.responseText;

          try {
            const parsed = JSON.parse(response);

            this.contentES = parsed.es || '';
            this.contentEN = parsed.en || '';

            // 🔥 SIEMPRE reset (clave)
            this.isENManuallyEdited = false;

          } catch {
            this.contentES = response;
            this.contentEN = '';
            this.isENManuallyEdited = false;
          }

          resolve();
        }
      };

      xhr.send();
    });
  }

  /* ============================================================
     UI ACTIONS
  ============================================================ */

  selectLanguage(lang: 'es' | 'en') {
    this.selectedLanguage = lang;
  }

  switchEditingTerms() {
    this.isEditingTerms = !this.isEditingTerms;
  }

  /* ============================================================
     SAVE (🔥 FIX REAL AQUÍ)
  ============================================================ */

  async saveTermsAndConditions() {
    this.loading = true;

    const stage = environment.stage === 'test' ? 'dev' : environment.stage;

    // 🔥 CLAVE: decidir EN en el SAVE, no en setter
    let finalEN: string | null = this.contentEN;

    if (this.selectedLanguage === 'es') {
      finalEN = null; // 🔥 FORZAR TRADUCCIÓN
      this.isENManuallyEdited = false;
    }

    const payload = JSON.stringify({
      es: this.contentES,
      en: this.isENManuallyEdited ? this.contentEN : finalEN
    });

    console.log('📦 PAYLOAD:', payload);

    this.isTranslating = !this.isENManuallyEdited;

    try {
      await this.lambdaService.uploadHtmlContent(
        `${this.themingService.shopId}/${stage}/config-files/terms-file.html`,
        payload,
        {}
      );

      await this.waitForTranslation();

      $('#successTermsModal').modal('show');

    } catch (error) {
      console.error('Error saving:', error);
      $('#errorTermsModal').modal('show');
    }

    this.loading = false;
    this.isTranslating = false;
    this.isEditingTerms = false;
  }

  /* ============================================================
     WAIT FOR TRANSLATION
  ============================================================ */

  private async waitForTranslation(maxAttempts = 10, delayMs = 1500) {
    for (let i = 0; i < maxAttempts; i++) {

      await this.loadPolicy();

      if (this.contentEN && this.contentEN.trim()) {
        console.log('✅ Translation ready');
        return;
      }

      console.log(`⏳ Waiting translation... ${i + 1}`);

      await new Promise(res => setTimeout(res, delayMs));
    }

    console.warn('⚠️ Translation timeout');
  }

  /* ============================================================
     MODALS
  ============================================================ */

  closeModal() {
    $('#successTermsModal').modal('hide');
    $('#errorTermsModal').modal('hide');
  }
}